module.exports = __webpack_public_path__ + "static/media/ActivitySub2.6d48596b.png";